import { Injectable, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BehaviorSubject, Observable, Subscription, take } from "rxjs";
import { ConfirmDialogComponent, ConfirmDialogData } from "../dialogs/confirm-dialog/confirm-dialog.component";
import { DisplayFormErrorsDialogComponent } from "../dialogs/display-form-errors-dialog/display-form-errors-dialog.component";
import { ProjectSelectorDialogComponent } from "shared/dialogs/project-selector-dialog/project-selector-dialog.component";
import { ChecklistLibraryDialogComponent } from "shared/dialogs/checklist-library-dialog/checklist-library-dialog.component";
import { ChecklistTemplate } from "shared/models/checklist-template";
import { SetReminderDialogComponent } from "shared/dialogs/set-reminder-dialog/set-reminder-dialog.component";
import { Utils } from "shared/utils/utils";

@Injectable({
  providedIn: 'root'
})
export class DialogService implements OnDestroy {
  private _subscriptions: Subscription[] = [];
  constructor(
    private dialog: MatDialog,
  ) {

  }

  confirmDialog(data: ConfirmDialogData): Observable<boolean | null> {
    let toReturn = new BehaviorSubject<boolean | null>(null);

    this._subscriptions.push(this.dialog.open(ConfirmDialogComponent, {
      data,
      panelClass: 'fakturnia-responsive-dialog'
    })
      .afterClosed()
      .subscribe(
        {
          next: (data) => {

            if (!Utils.isDefined(data, "action")) { toReturn.next(false); return; }

            if (data.action == true) {
              toReturn.next(true)
            }
            else if (data.action == false) {
              toReturn.next(false)
            }
          },
          error: (err) => {
            toReturn.next(false)
          }
        }
      ))

    return toReturn.asObservable();
  }

  public showFormErrorsDialog(errors: { field: string, errors: string[] }[]) {

    this.dialog.open(DisplayFormErrorsDialogComponent, {
      data: { errors: errors },
      panelClass: 'fakturnia-responsive-dialog',
      width: '500px'
    })

  }

  showSetReminderDialog(currentDate: Date | null): Observable<Date | null | undefined> {
    const dialogRef = this.dialog.open(SetReminderDialogComponent, {
      data: { currentDate },
      panelClass: 'fakturnia-responsive-dialog'
    });

    return dialogRef.afterClosed();
  }

  showChecklistLibraryDialog(mode: 'SELECT' | 'BROWSE', disabledList: string[] = []): Observable<ChecklistTemplate[] | null> {
    const dialogRef = this.dialog.open(ChecklistLibraryDialogComponent, {
      data: { mode, disabledList },
      panelClass: 'fakturnia-responsive-dialog'
    });

    return dialogRef.afterClosed();
  }

  showProjectSelectorDialog(data: any = null) {

    this.dialog.open(ProjectSelectorDialogComponent, {
      width: '550px',
      data,
      disableClose: true,
      panelClass: 'fakturnia-responsive-dialog'
    })
      .afterClosed()
      .subscribe({
        next: (response) => {
          if (!response) return
          console.log(response)
        }
      })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll();
  }

  private _unsubscribeAll() {
    // Print subs to delete
    this._subscriptions.forEach(sub => sub.unsubscribe());
    this._subscriptions = [];
  }
}